import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Button } from "@material-ui/core"
import { withRouter } from "react-router-dom"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as IssueActions from "../actions/IssueActions"
import * as UserActions from "../actions/UserActions"
import Login from "./Login"
import IssueChart from "./IssueChart"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
  },
  nav: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    //paddingTop: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: 0,
  },
  navRight: {
    display: "flex",
    paddingRight: "10px",
    //margin: "10px",
    justifyContent: "space-between",
  },
}))

const Welcome = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {props.users.isAuthenticated ? (
        <>
          <div className={classes.nav}>
            <p>Welcome {props.users.firstName}</p>
            <div className={classes.navRight}>
              <Button color="secondary" onClick={props.userActions.logoutUser}>
                Logout
              </Button>
            </div>
          </div>
          <IssueChart />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            height: "80vh",
          }}
        >
          <p>Welcome Guest,</p>
          <p>Login here with Email- <b>john.doe@test.com</b> and Password- <b>Test@123</b></p>

          <Login />
          <p>or use the tracker with limited access.</p>
          <p><b>Note- </b>As the Backend is hosted on JSON Server hence whatever data you entered and saved will be present only locally.</p>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Welcome))
